import styled from 'styled-components';

export default styled.div`
  position: absolute;
  right: -29px;
  width: 60px;
  text-align: left;
  top: 0;
  white-space: nowrap;
  .close-button, .close-button .ant-btn[disabled], .add-button .ant-dropdown-trigger {
    font-size: 1.1em;}
    width: 24px;
    margin-left: 15px;
    background-color: #ffffff;
  }
`;
